import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { LIST_COMPAIGN, LIST_COMPAIGN_SUCCESS, LIST_COMPAIGN_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* listCompaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: LIST_COMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LIST_COMPAIGN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LIST_COMPAIGN_ERROR, payload: error });
  }
}

export function* watchlistCompaign() {
  yield takeEvery(LIST_COMPAIGN, listCompaign);
}

function* listCompaignSaga() {
  yield all([fork(watchlistCompaign)]);
}

export default listCompaignSaga;
